@if (!isAppMobile) {
  <h1 class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
    {{ 'coordonnees.titre' | translate }}
  </h1>
}
<h2 id="titreCourriel" tabindex="-1" class="dsd-t-3 dsd-mb-sm">
  {{
    (estCourrielExistant ? 'modifierCourriel.titreModifier' : 'modifierCourriel.titreAjouter')
      | translate
  }}
</h2>
<dsd-form
  (dsdFormSubmit)="naviguerVersValidation()"
  noErrorSummary
  hide-required-labelling="form-required-text"
>
  <p class="dsd-fw-bold dsd-b-40 dsd-mb-sm">
    {{ 'modifierCourriel.champObligatoire' | translate }}
  </p>
  <ng-container [formGroup]="formGroup">
    <dsd-container>
      <dsd-input
        #courriel
        required="true"
        identifier="courriel"
        formControlName="courriel"
        [maxlength]="50"
        [minlength]="6"
        name="courriel"
        type="email"
      >
        <span slot="label">{{ 'modifierCourriel.adresse' | translate }}</span>
        <span slot="error">
          <span data-error-key="maxlength">{{
            'modifierCourriel.erreur.minMaxLength' | translate
          }}</span>
          <span data-error-key="minlength">{{
            'modifierCourriel.erreur.minMaxLength' | translate
          }}</span>
          <span data-error-key="default">{{
            'modifierCourriel.erreur.courrielInvalide' | translate
          }}</span>
        </span>
      </dsd-input>
    </dsd-container>
  </ng-container>
  <div class="zone-btn">
    <!-- Bouton Confirmer -->
    <dsd-button variant="primary" type="submit" full-width="xs">
      {{ 'bouton.valider' | translate }}
    </dsd-button>
    <!-- Bouton Annuler -->
    <dsd-button full-width="xs" id="btnAnnuler" (dsdButtonClick)="annuler()">
      {{ 'bouton.annuler' | translate }}
    </dsd-button>
  </div>
</dsd-form>
